import { render, staticRenderFns } from "./xmlxxx.vue?vue&type=template&id=63a3be1e&scoped=true"
import script from "./xmlxxx.vue?vue&type=script&lang=js"
export * from "./xmlxxx.vue?vue&type=script&lang=js"
import style0 from "./xmlxxx.vue?vue&type=style&index=0&id=63a3be1e&prod&scoped=true&lang=scss"
import style1 from "./xmlxxx.vue?vue&type=style&index=1&id=63a3be1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a3be1e",
  null
  
)

export default component.exports